import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { DialogService } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { some } from 'lodash';
import {
  Observable,
  catchError,
  combineLatest,
  startWith,
  takeUntil,
  tap,
  throwError,
} from 'rxjs';
import { SCHEDULE_MEETING_CONSTANTS } from 'src/app/modules/student-info/schedule-meeting/schedule-meeting-constants';
import { DocumentService } from 'src/app/services/document.service';
import { AbstractForm } from 'src/app/shared/components/abstract-form';
import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { DocumentType } from '../../enums/document-types';
import { OperationType } from '../../enums/operation-type';
import { formType } from '../../enums/switch-case';
import { sanitizeJsonString } from '../../functions/sanitizeJsonString';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { StudentRelatedEventReferenceData } from '../../interfaces/form/student-related-event-data.model';
import { StudentDetails } from '../../interfaces/student';
import { StudentDocument } from '../../interfaces/student-document';
import { AddStudentRelatedEventFormModel } from '../../models/student-related-events-models/student-related-event-formmodel';
import { SudentRelatedEventsModel } from '../../models/student-related-events-models/student-related-event-response-model';
import { SubmitSudentRelatedEventsModel } from '../../models/student-related-events-models/submit-student-related-event-model';
import { User } from '../../models/user';
import { UserRole } from '../../models/user-role';
import { ContributorService } from '../../services/contributor-service';
@Component({
  selector: 'app-student-related-events',
  templateUrl: './student-related-events.component.html',
  styleUrls: ['./student-related-events.component.scss'],
  standalone: false,
})
export class StudentRelatedEventsComponent extends AbstractForm<
  SudentRelatedEventsModel,
  SudentRelatedEventsModel,
  Record<string, IReferenceData[]>
> {
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Input() stdentDetails: any; // TODO: need to change this to a specific type
  @Input() outreachSk: string;
  @Input() studentSk$: string;
  @Input() action: string;
  @Input() nycIds: string;
  @Input() isEI: boolean;
  selectedAction: string;
  timePickerValue: Date = SCHEDULE_MEETING_CONSTANTS.timePickerDefaultValue;
  showPreviousAttemptsBtn: boolean;
  dropDownValues: IReferenceData[];
  loadSpinner: boolean;
  loadSpinners: boolean;
  showToPhone: boolean;
  showToEmail: boolean;
  showToPostal: boolean;
  studentDetails: StudentDetails;
  showFromEmail: boolean;
  showFromPhone: boolean;
  showFromPostal: boolean;
  studentSk: string;
  dateTimeOccured: string;
  canTogleSelected: boolean = true;
  studentRelatedEvent: string;
  studentRelatedEventFormJson: string;
  showInreach: boolean;
  currentDate: Date = new Date();
  isLogEventSubmitted: boolean = false;
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  showRelatedActionOther: boolean;
  showEIOutreachOther: boolean;
  relatedActionDropDown: IReferenceData[];
  showEIOutreachToFromDropdown: boolean = true;
  isReadonly: boolean;
  readonly outreach: string = 'Outreach';
  readonly inReach: string = 'In-reach';
  readonly viewAction: string = 'view';
  readonly deleteAction: string = 'delete';
  readonly editAction: string = 'edit';
  readonly otherRelatedAction: string = 'Other';
  readonly outreachHomeVisit: number = 4;
  readonly outreachSchoolVisit: number = 5;
  readonly outreachPhysicalPostalMail: number = 6;
  readonly dateSliceStartIndex: number = 0;
  readonly dateSliceEndIndex: number = 10;
  readonly timeSliceStartIndex: number = 11;
  readonly timeSliceEndIndex: number = 19;
  iepFormSk: string;
  user: User;
  finalizeShown: boolean = true;
  form: FormGroup;
  formModel: ISedmsFormModel = AddStudentRelatedEventFormModel;
  showOtherInput: boolean;
  locked: boolean = false;
  userDetails: User;
  todayDate: Date = new Date();
  uploadedDocuments: StudentDocument[] = [];
  excludeEngagementStatus: number[] = [6, 7, 8];

  constructor(
    private authStore: AuthStore,
    notificationService: NotificationService,
    private documentService: DocumentService,
    private referenceStore: ReferenceStore,
    public service: ContributorService,
    dialogService: DialogService,
    cdRef: ChangeDetectorRef,
    route: ActivatedRoute,
    formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute
  ) {
    super(cdRef, route, formBuilder, dialogService, notificationService);
    this.user = this.authStore.UserInfo;
    this.authStore.UserInfo$.pipe(takeUntil(this.componentDestroyed)).subscribe(
      (userInfo: User) => {
        this.userDetails = userInfo;
      }
    );

    this.loadSpinner = true;
  }

  get entity$(): Observable<SudentRelatedEventsModel> {
    return this.service.getUserEvents(this.outreachSk);
  }
  // For Getting Data from Dropdown
  get referenceData$(): Observable<IReferenceData[][]> {
    return combineLatest([
      this.referenceStore.engagementstatus$,
      this.referenceStore.outreachMethod$,
      this.referenceStore.studRelatedEvents$,
      this.referenceStore.language$,
      this.referenceStore.eiOutreachToFrom$,
    ]);
  }
  get getEngageStatus(): IReferenceData[] {
    if (this.selectedAction !== this.outreach) {
      return this.referenceData.engagementstatus.filter(
        (data: IReferenceData) =>
          !this.excludeEngagementStatus.includes(data.id as number)
      );
    } else {
      return this.referenceData.engagementstatus;
    }
  }
  //get dropdown details data and entity get by Id Data
  initEntity(
    entityData: unknown,
    referenceData: Record<string, IReferenceData[]>
  ): SudentRelatedEventsModel {
    return new SudentRelatedEventsModel(entityData, referenceData);
  }

  initReferenceData([
    engagementstatus,
    outreachMethod,
    outreachType,
    language,
    eIOutreachToFrom,
  ]: [
      IReferenceData[],
      IReferenceData[],
      IReferenceData[],
      IReferenceData[],
      IReferenceData[]
    ]): StudentRelatedEventReferenceData {
    return {
      engagementstatus,
      outreachMethod,
      outreachType,
      language,
      eIOutreachToFrom,
    };
  }

  getAction(name: string): void {
    if (name === this.outreach) {
      this.selectedAction = name;
      this.showPreviousAttemptsBtn = true;
      this.canTogleSelected = false;
      if (this.form.get('from').value === null) {
        this.form.get('from').setValue(this.userDetails?.username);
        this.form.get('to').setValue(null);
      }
    } else if (name === this.inReach) {
      this.selectedAction = name;
      this.showPreviousAttemptsBtn = false;
      this.canTogleSelected = false;
      if (this.form.get('to').value === null) {
        this.form.get('to').setValue(this.userDetails?.username);
        this.form.get('from').setValue(null);
      }
    }
  }

  get getOutreachMetod(): IReferenceData[] {
    if (this.selectedAction === this.inReach) {
      return this.referenceData.outreachMethod.filter(
        (data: IReferenceData) =>
          data.id !== this.outreachHomeVisit &&
          data.id !== this.outreachSchoolVisit
      );
    } else {
      return this.referenceData.outreachMethod;
    }
  }

  get canSubmited(): boolean {
    return this.action === this.viewAction;
  }
  get disableToggle(): boolean {
    return this.action === this.viewAction || this.action === this.editAction;
  }
  get canDeleted(): boolean {
    return this.action === this.deleteAction;
  }
  initWatches(): void {
    if (this.stdentDetails?.eiId !== null) this.isEI = true;
    if (
      this.isEI &&
      some(this.userDetails.userRoles, (x: UserRole) => x.roleName !== 'dece')
    ) {
      this.relatedActionDropDown = this.referenceData.outreachType.filter(
        (data: IReferenceData) => data?.value !== 'EI - TC'
      );
    } else if (
      this.isEI &&
      some(this.userDetails.userRoles, (x: UserRole) => x.roleName === 'dece')
    ) {
      this.relatedActionDropDown = this.referenceData.outreachType;
    } else {
      this.showEIOutreachToFromDropdown = false;
      this.relatedActionDropDown = this.referenceData.outreachType;
    }
    if (this.outreachSk) {
      this.service
        .getUserEvents(this.outreachSk)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((data) => {
          //TODO:We need to add types for the api endpoints, once added we need to add the types to the subscribe method
          if (data?.value?.formJson) {
            //TODO:We need to add types for the api endpoints, once added we need to add the types to the DATS variable
            const DATS = JSON.parse(sanitizeJsonString(data?.value?.formJson));
            const DATAS: SudentRelatedEventsModel =
              new SudentRelatedEventsModel(DATS, this.referenceData);
            if (DATAS.eventType === this.outreach) {
              this.selectedAction = DATAS.eventType;
              this.showPreviousAttemptsBtn = true;
            } else if (DATAS.eventType === this.inReach) {
              this.selectedAction = DATAS.eventType;
              this.showPreviousAttemptsBtn = false;
            }
            this.form.patchValue(DATAS);
            if (this.action === this.viewAction || this.action === this.deleteAction) {
              this.form.get('logEventFile')?.disable();
            } else if (this.action === this.editAction) {
              this.getAction(DATAS.eventType);
              this.form.enable();
              this.isReadonly = false;
            }
          }
          this.loadSpinner = false;
        });
    } else {
      this.loadSpinner = false;
    }

    this.form
      .get('contactMethod')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('contactMethod')?.value)
      )
      .subscribe((value: IReferenceData) => {
        switch (value?.id) {
          case formType.one:
            this.setShowFromProperties(false, true, false);
            break;
          case formType.three:
            this.setShowFromProperties(true, false, false);
            break;
          case formType.six:
            this.setShowFromProperties(false, false, true);
            break;
          default:
            this.setShowFromProperties(false, false, false);
            break;
        }
      });
    this.form
      .get('relatedAction')
      ?.valueChanges.pipe(takeUntil(this.componentDestroyed))
      .subscribe((value: IReferenceData) => {
        if (value?.description === this.otherRelatedAction) {
          this.showRelatedActionOther = true;
        } else {
          this.showRelatedActionOther = false;
        }
      });
    this.form
      .get('eIOutreachToFrom')
      ?.valueChanges.pipe(takeUntil(this.componentDestroyed))
      .subscribe((value: IReferenceData) => {
        if (value?.value === this.otherRelatedAction) {
          this.showEIOutreachOther = true;
        } else {
          this.showEIOutreachOther = false;
        }
      });
  }

  setShowFromProperties(
    showFromEmail: boolean,
    showFromPhone: boolean,
    showFromPostal: boolean
  ): void {
    if (this.selectedAction === this.inReach) {
      this.showFromEmail = showFromEmail;
      this.showFromPhone = showFromPhone;
      this.showFromPostal = showFromPostal;
      this.showToEmail = false;
      this.showToPhone = false;
      this.showToPostal = false;
    } else {
      this.showToEmail = showFromEmail;
      this.showToPhone = showFromPhone;
      this.showToPostal = showFromPostal;
      this.showFromEmail = false;
      this.showFromPhone = false;
      this.showFromPostal = false;
    }
  }

  public override otherInitalizations(): void {
    this.form.get('dateOccurred').setValue(this.todayDate);

    const USERNAME: string = this.userDetails?.username;
    this.form.get('from').patchValue(USERNAME);
    if (this.outreachSk !== undefined && this.outreachSk !== null) {
      this.documentService
        .getCaseActionDocuments(this.studentSk$, this.outreachSk)
        .subscribe((res: StudentDocument[]) => {
          this.uploadedDocuments = [...res];
        });
    }
  }

  public override afterOnDestroy(): void {
    // afterOnDestroy
  }

  postCancelConfirmation(): void {
    this.loadSpinners = false;
  }

  //TODO:We need to add types for the api endpoints, once added we need to add the types to the response.
  postSubmitConfirmation(isSubmit: boolean, response: any): void {
    this.uploadDocuments(response);
    if (this.form.get('logEventFile')?.value) this.loadSpinner = false;
    else this.closeDailog();
  }

  closeDailog(): void {
    this.close.next();
  }
  saveDetails(): Observable<SudentRelatedEventsModel> {
    this.loadSpinner = true;
    this.isLogEventSubmitted = true;
    this.getDateAndTime();
    const SUBMIT_STUDENT_RELATED_EVENTS_MODEL: SubmitSudentRelatedEventsModel =
      new SubmitSudentRelatedEventsModel({
        ...this.form.getRawValue(),
        eventType: this.selectedAction,
      });
    SUBMIT_STUDENT_RELATED_EVENTS_MODEL.studentSk =
      this.studentSk$ === undefined ? this.studentSk : this.studentSk$;
    SUBMIT_STUDENT_RELATED_EVENTS_MODEL.dateTimeoccured = this.dateTimeOccured;
    SUBMIT_STUDENT_RELATED_EVENTS_MODEL.caseactionsk = this.outreachSk;
    SUBMIT_STUDENT_RELATED_EVENTS_MODEL.personSk = this.userDetails?.personSk;
    SUBMIT_STUDENT_RELATED_EVENTS_MODEL.studentOSISId =
      this.studentDetails?.nycId;
    SUBMIT_STUDENT_RELATED_EVENTS_MODEL.schoolDBN =
      this.studentDetails?.schoolDBN;
    if (this.action === this.deleteAction) {
      SUBMIT_STUDENT_RELATED_EVENTS_MODEL.operation = OperationType.Delete;
    } else if (this.action === this.editAction) {
      SUBMIT_STUDENT_RELATED_EVENTS_MODEL.operation = OperationType.Edit;
    } else {
      SUBMIT_STUDENT_RELATED_EVENTS_MODEL.operation = OperationType.Add;
    }
    this.studentRelatedEventFormJson =
      SUBMIT_STUDENT_RELATED_EVENTS_MODEL?.formJson;

    return this.service
      .submitStudentRelatedEvent(SUBMIT_STUDENT_RELATED_EVENTS_MODEL)
      .pipe(
        tap(() => {
          this.isLogEventSubmitted = false;
        }),
        catchError((error) => {
          // Not Sure What data type will be for error params.
          this.isLogEventSubmitted = false;
          return throwError(() => new Error(error));
        })
      );
  }
  getDateAndTime(): void {
    const DATE_STSRING: Date = this.form.get('dateOccurred').value;
    const TIME_OCCURED: Date = this.form.get('timeOccurred').value;
    if (DATE_STSRING === null || TIME_OCCURED === null) {
      return;
    }

    const DATE: Date = new Date(DATE_STSRING);
    const DATE_OCCURED: string = DATE.toISOString().slice(
      this.dateSliceStartIndex,
      this.dateSliceEndIndex
    );
    const TIME: Date = new Date(TIME_OCCURED);
    const TIME_OCCURED2: string = TIME.toISOString().slice(
      this.timeSliceStartIndex,
      this.timeSliceEndIndex
    ); // Extract the time portion (HH:mm:ss)
    this.dateTimeOccured = `${DATE_OCCURED}T${TIME_OCCURED2}.000Z`;
  }

  //TODO:We need to add types for the api endpoints, once added we need to add the types to the response.
  public uploadDocuments(response): void {
    const FORM_DATA: FormData = new FormData();
    if (!this.form.get('logEventFile')?.value) return;
    for (const FILEOBJ of this.form.get('logEventFile')?.value) {
      FORM_DATA.append(
        'id',
        this.stdentDetails?.nycId === undefined
          ? this.nycIds
          : this.stdentDetails?.nycId
      );
      FORM_DATA.append('studentSk', response?.value?.studentSk);
      FORM_DATA.append('caseActionSk', response?.value?.caseactionsk);
      FORM_DATA.append(
        'formJson',
        JSON.stringify(this.studentRelatedEventFormJson)
      );
      FORM_DATA.append('documentType', DocumentType.UserEvent);
      if (FILEOBJ.rawFile) {
        FORM_DATA.append('file', FILEOBJ.rawFile!);
      } else {
        FORM_DATA.append('file', FILEOBJ);
      }
    }

    this.documentService.uploadDocument(FORM_DATA).subscribe(() => {
      this.closeDailog();
    });
  }
  get canSaveDraft(): boolean {
    return !this.form.valid;
  }

  get canSubmit(): boolean {
    return false;
  }

  get checkCondition(): string {
    if (this.outreachSk) {
      return 'action-page-footer';
    } else {
      return 'page-footer';
    }
  }
}
